
import '../style.css';
import Carousel from './carousel'
import GuanteoCard from './GuanteoCard.jsx'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import MayoristaModal from './MayoristaModal';
import FaqSection from './FaqSection';
import { FaYoutube, FaInstagram, FaGlobe } from 'react-icons/fa';


function Index() {

const [showModal, setShowModal] = useState(false);
   
     return ( 
       <div className="indexprincipal">
   
       

        <div className="top-banner d-flex justify-content-between align-items-center px-3 py-2">
          {/* Imagen a la izquierda */}
          <div className="banner-image">
            <img src="guanteazul.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>

          {/* Título del juego */}
          <div className="banner-title text-center flex-grow-1">
            <h1 className="m-0, bungee-regular">Guanteo</h1>
          </div>

          {/* Logo editorial a la derecha */}
          <div className="banner-logo">
            <img src="guanterojo.png" alt="Logo Editorial" className="img-fluid img-guantes-banner" />
          </div>
        </div>





       
        <Carousel/> 

        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
              <div className="guanteo-descripcion">
                <h2 className='bungee-regular'>🥊 Guanteo: Golpeá con Memoria. Ganá con Estrategia.</h2>
                <p>
                  <strong>Un duelo cara a cara donde cada decisión puede cambiar el rumbo del combate.</strong><br /><br />
                  En <strong>Guanteo</strong>, dos jugadores se enfrentan en un ring de 16 cartas dispuestas al azar. Cada uno comienza con el control de 8, pero solo quien logre quedarse con <strong>12 cartas al final de su turno</strong> será el campeón.<br /><br />
                  🎯 <strong>¿El desafío?</strong><br />
                  Tus cartas (y las del rival) están boca abajo toda la partida. Para ganar, vas a tener que <strong>memorizar, anticipar y golpear con precisión</strong>. Si errás... podrías terminar golpeándote a vos mismo.<br /><br />
                  🧠 <strong>Memoria + Estrategia</strong><br />
                  Cada jugador tiene su propio mazo (rojo o azul) y deberá usar sus cartas con inteligencia para atacar, abrirse camino en el tablero y robar nuevas cartas. Pero cada acción mal ejecutada puede ser un paso hacia la derrota.<br /><br />
                  🔁 <strong>Cada turno cuenta</strong><br />
                  Atacar al rival te da ventajas: más cartas, más información, más chances de recuperar el control del tablero. Pero también podés intercambiar cartas, planear tu próximo movimiento o ejecutar combos... <strong>si recordás qué hay bajo cada carta.</strong><br /><br />
                  ⚠️ <strong>No es solo golpear. Es saber cuándo, cómo y dónde hacerlo.</strong>
                </p>
                 <div className="manual-cta text-center mt-4">
              <p className="mb-3">¿Querés leer el manual?</p>
              <Button variant="warning" size="lg" href="/Reglamento Guanteo.pdf" target="_blank" className="guanteo-btn">
                📖 Ver Manual
              </Button>
            </div>
              </div>
              
            </Col>
          </Row>
           <Row>
           
          </Row>
     
      </Container>

        <Container>
          <Container className="my-5">
             <h2 className="text-center guanteo-subtitulo mt-5">
        📹 Guanteo en Acción: Como se juega
      </h2>
    
             <Row className="g-4 justify-content-center">
              {/*<Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="logo192.png"
                  description="Aprendé las reglas básicas y cómo empezar a jugar Guanteo en 5 minutos."
                  videoLink="https://www.youtube.com/watch?v=video1"
                />
              </Col>*/}
              <Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="fondovideo.png"
                  description="Te Contamos Como Jugar"
                  videoLink="https://youtu.be/igyrygoI9g0?si=OhHZbfoc2hY1KGXG"
                />
              </Col>
              {/*<Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="logo192.png"
                  description="Consejos avanzados para mejorar tu memoria y usar combos a tu favor."
                  videoLink="https://www.youtube.com/watch?v=video3"
                />
              </Col>*/}
            </Row>
           
          </Container>
      
        <Container fluid className="guanteo-banner mt-5 py-5">
        <Row className="justify-content-center text-center">
          <Col xs={12} md={10} lg={8}>
            <h3 className="guanteo-banner-title mb-4">
              💥 ¿Listo para subir al ring? ¡Conseguí tu Guanteo hoy!
            </h3>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <Button 
                variant="warning" 
                size="lg" 
                href="https://www.tienda.kitsunegames.ar/productos/guanteo/"
                className="guanteo-banner-btn"
              >
                🛒 Ir a la Tienda
              </Button> 
             
                  <Button 
              variant="outline-light" 
              size="lg" 
              onClick={() => setShowModal(true)}
              className="guanteo-banner-btn"
            >
              🧾 Venta Mayorista
            </Button>

            <MayoristaModal show={showModal} handleClose={() => setShowModal(false)} />
                  </div>
                </Col>
        </Row>
      </Container>


        <FaqSection />

        <footer className="footer text-white py-4">
  <div className="container">
    <div className="row text-center text-md-start align-items-center">

      {/* Logo y nombre de la editorial */}
      <div className="col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
        <img
          src="logokitsune.png"
          alt="Logo Editorial"
          className="footer-editorial-logo mb-2"
        />
       
      </div>

      {/* Nombre del juego y tagline */}
      <div className="col-md-6 mb-4 mb-md-0 text-center">
        <h5 className="fw-bold bungee-regular">Guanteo</h5>
        <p className="mb-2">Un juego de Memoria y Estrategia</p>
        <div className="social-icons d-flex justify-content-center gap-3">
          <a
            href="https://www.youtube.com/@Kitsunegamesar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube size={24} />
          </a>
          <a
            href="https://www.instagram.com/kitsunegames.ar/"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.kitsunegames.ar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGlobe size={24} />
          </a>
        </div>
      </div>

      {/* Leyenda de derechos */}
      <div className="col-md-3 text-center text-md-end">
        <p className="mb-1">© {new Date().getFullYear()} Editorial KitsuneGames</p>
        <p className="mb-0">Todos los derechos reservados.</p>
      </div>
    </div>
  </div>
</footer>


</Container>
       </div>
       
     );
   }
   
   export default Index;